































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import SheetListTab from "../../components/SheetListTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, Student } from "../../modules/teacher/ResultStudentList"


export interface Data {
  tabNo: number
  sheet_group_key: string
  room_id: string
  room_name: string
  sheet: Sheet
  students: Student[]
  releaseFlg: boolean
  KindEnum: Readonly<{TwentyMin: number; Various: number; Kimatsu: number}>
  errors: string[]
}

export default defineComponent({
  components: {
    "sheet-list-tab": SheetListTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * ref
     ******************************/

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 3,
      sheet_group_key: "",
      room_id: "",
      room_name: "",
      sheet: new Sheet({}),
      students: new Array<Student>(),
      releaseFlg: false,
      KindEnum: Common.KindEnum,
      errors: [],
    });

    /************************************************************
     * 公開フラグ変更イベント
     ************************************************************/

    const releaseFlgChanged = async (changedVal: boolean) => {

      await http.post(`/api/result_student_list/update_release_flg/${state.sheet_group_key}/${state.room_id}`, {release_flg: changedVal}).then(response => {
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * ダウンロード
     ************************************************************/

    const downloadExcel = async (): Promise<void> => {

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/result_student_list/download_excel/${state.sheet_group_key}/${state.room_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        let kindResultName: string = "";
        if(state.sheet.kind == state.KindEnum.TwentyMin){
          kindResultName = "20分テスト結果"
        }else if(state.sheet.kind == state.KindEnum.Various){
          kindResultName = "諸テスト結果"
        }
        a.download = kindResultName + `_${moment().format('Y-M-D')}.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 分布ボタン押下
     ******************************/

    const toDistribution = () => {
      context.root.$store.commit("setResultDistributionRoomId", state.room_id);
      context.root.$router.push(`/teacher_site/result_distribution_list/${state.sheet_group_key}/${state.room_id}`).catch(() => {});
    };

    /******************************
     * 試験一覧（成績）に遷移
     ******************************/

    const toResultList = () => {
      context.root.$router.push(`/teacher_site/result_list`).catch(() => {});
    };

    /******************************
     * 生徒成績詳細に遷移
     ******************************/

    const toResultStudentDetail = (student: Student) => {
      context.root.$store.commit("setResultStudentDetailSheetGroupKey", state.sheet_group_key);
      context.root.$store.commit("setResultStudentDetailRoomId", state.room_id);
      context.root.$store.commit("setStudentNum", `${student.student_num}`);
      if(state.sheet.kind == state.KindEnum.TwentyMin){
        context.root.$router.push({path: `/teacher_site/result_student_twenty`, query: {sheet_group_key: state.sheet_group_key}}).catch(() => {});
      }else if(state.sheet.kind == state.KindEnum.Various){
        context.root.$router.push({path: `/teacher_site/result_student_various`, query: {sheet_group_key: state.sheet_group_key}}).catch(() => {});
      }
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      state.room_id = context.root.$route.params.room_id;
      context.root.$store.commit("setStudentNum", null);
      await http.get(`/api/result_student_list?sheet_group_key=${state.sheet_group_key}&room_id=${state.room_id}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.students = response.data.students.map((x: any) => new Student(x));
        state.room_name = state.students.length > 0 ? state.students[0].room_name : "";
        state.releaseFlg = response.data.release_flg;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      releaseFlgChanged,
      downloadExcel,
      toDistribution,
      toResultList,
      toResultStudentDetail,
    }
  }
});
